import { FC } from "react";

export const SimpleTextCell: FC<{ text: string }> = ({ text }) => {
  return (
    <div className="font-medium text-sm text-white whitespace-nowrap overflow-hidden text-ellipsis">
      {text}
    </div>
  );
};
